var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTtb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0157 82.9455C18.8247 82.9455 13.0319 77.1527 13.0319 69.9617V57.4774H25.5162V45.4924H13.0319V33.0078H1.04688V69.9617C1.04688 83.7445 12.233 94.9306 26.0157 94.9306C33.6061 94.9306 40.3978 91.5347 44.9919 86.1415C41.2966 81.7471 38.9994 76.1539 38.9994 69.9617C38.9994 77.0528 33.1068 82.9455 26.0157 82.9455Z",
    fill: "#0050EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9527 69.9617C76.9527 77.1527 71.1599 82.9455 63.9689 82.9455C56.7779 82.9455 50.985 77.1527 50.985 69.9617V57.4774H63.4696V45.4924H50.985V33.0078H39V69.9617C39 76.1539 41.2973 81.8468 44.9925 86.1415C49.5868 91.5347 56.3783 94.9306 63.9689 94.9306C71.5595 94.9306 78.3509 91.5347 82.9452 86.1415C79.1498 81.7471 76.9527 76.1539 76.9527 69.9617Z",
    fill: "#F58B1E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M101.922 44.9928C97.1278 44.9928 92.7333 46.2913 88.9381 48.5883V33.0078H76.9531V69.9617C76.9531 76.1539 79.2502 81.8468 82.9456 86.1415C87.5397 91.5347 94.3314 94.9306 101.922 94.9306C115.705 94.9306 126.891 83.7445 126.891 69.9617C126.891 56.1789 115.705 44.9928 101.922 44.9928ZM101.922 82.9455C94.7307 82.9455 88.9381 77.1527 88.9381 69.9617C88.9381 62.7707 94.7307 56.9778 101.922 56.9778C109.113 56.9778 114.906 62.7707 114.906 69.9617C114.906 77.1527 109.013 82.9455 101.922 82.9455Z",
    fill: "#002D64"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTtb);
export default __webpack_public_path__ + "static/media/ttb -ธนาคารทหารไทยธนชาต.3f66dfe74f14f1aa1da743e3ad21461e.svg";
export { ForwardRef as ReactComponent };